import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Divider, ExpandableListItem, IconButton, List, ListItem } from '@fs/zion-ui'
import { Menu, PlaceHome } from '@fs/zion-icon'
import { cssDropDownMenu, cssGlow } from '../../LcrDemo/common/styles'
import MenuItemWithGlow from './MenuItemWithGlow'
import TempleSubMenuItems from './TempleSubMenuItems'
import useMenuEventHandlers from './useMenuEventHandlers'

/**
 * @describe - Render a single Nav Menu Item for the LCR Menu (Mobile Version).
 */
export default function LcrNavBarItemMobile({ isLcrDashboard, templeSubMenuItems = [], menuOptions = [] }) {
  const [t] = useTranslation()
  const lcrHomeLink = t('lcr.navbar.item.lcr-home.label', 'LCR Home')
  const [showSubMenu, setSubMenu] = useState()

  const handleMenuClick = useCallback(() => {
    setSubMenu((prev) => !prev)
  }, [])

  const { handleMenuEvent: handleTempleMenuClick } = useMenuEventHandlers(handleMenuClick)

  const templeMenuAriaLabel = t('lcr.navbar.item.temple.aria-label', 'Temple Menu')

  return (
    <>
      <MenuItemWithGlow showGlow={isLcrDashboard && !showSubMenu}>
        <IconButton
          data-testid="hamburger-nav-button"
          title={lcrHomeLink}
          Icon={Menu}
          onClick={handleTempleMenuClick}
          aria-label={templeMenuAriaLabel}
          disabled={!isLcrDashboard}
        />
      </MenuItemWithGlow>
      {showSubMenu && (
        <List>
          <div css={cssDropDownMenu}>
            <ListItem primaryText={lcrHomeLink} startElement={<ListItem.Icon Icon={PlaceHome} />} disabled />
          </div>

          <ExpandableListItemGlow
            menuOptions={menuOptions}
            templeSubMenuItems={templeSubMenuItems}
            handleTempleMenuClick={handleTempleMenuClick}
          />
        </List>
      )}
    </>
  )
}

function ExpandableListItemGlow({ menuOptions, templeSubMenuItems, handleTempleMenuClick }) {
  const [menuOpen, setMenuOpen] = useState(false)

  const handleMenuClick = useCallback((value) => {
    setMenuOpen((preValue) => value(preValue))
  }, [])

  return menuOptions.map((menuOptionProps) => (
    <React.Fragment key={menuOptionProps.menuText}>
      <Divider />

      <ExpandableListItem
        data-testid={menuOptionProps.showGlowMenu ? 'lcr-menu-item.temple' : undefined}
        primaryText={
          <div css={menuOptionProps.showGlowMenu && !menuOpen ? cssGlow : undefined}>{menuOptionProps.menuText}</div>
        }
        open={menuOpen}
        setOpen={menuOptionProps.showGlowMenu ? handleMenuClick : undefined}
        disabled={!menuOptionProps.showGlowMenu}
      >
        {menuOptionProps.showGlowMenu && (
          <TempleSubMenuItems
            showDividers
            templeSubMenuItems={templeSubMenuItems}
            handleMenuItemClick={handleTempleMenuClick}
            inlineMargin
          />
        )}
      </ExpandableListItem>
    </React.Fragment>
  ))
}
